import { Fulfillment } from "@secondcloset/types";

import { stringify } from "query-string";

import { getAPIFromDomain } from "../../lib/api";
import { APIVersion } from "@secondcloset/api-utils";

type Shipment = Fulfillment.Shipment;
type DeliveryType = Fulfillment.DeliveryType;

export interface ShipmentIndexQuery {
  per_page: number;
  organization_id?: string;
  page?: number;
  status?: string;
  date_to?: string;
  date_from?: string;
  billed?: boolean;
  shipment_item_actions?: string[];
  shipping_methods?: string[];
  organizations?: string[];
  with_organization?: boolean;
  with_external_order?: boolean;
  freight?: boolean;
  delivery_types?: DeliveryType[];
  external_search?: string;
  with_shipping_labels?: boolean;
}

interface ShipmentUpdateBody {
  label_id: string;
  tracking_number: string;
  bol_file: File;
  freight: boolean;
  facility_id: string;
}

export const fetchShipmentIndex = async (query: ShipmentIndexQuery): Promise<Shipment[]> => {
  const api = getAPIFromDomain("logistics");
  const q = stringify(query, { arrayFormat: "bracket" });
  const url = `/shipments?${q}`;
  const res = await api.get(url);
  return res.data;
};

export const cancelPackageDelivery = (packageID: string, shipmentID: string) => {
  const api = getAPIFromDomain("logistics");
  const url = `/shipment_packages/${packageID}/cancelled`;
  return api.put(url, { shipment_id: shipmentID });
};

export const redeliverPackage = (packageID: string, shipmentID: string) => {
  const api = getAPIFromDomain("logistics");
  const url = `/shipment_packages/${packageID}/redelivered`;
  return api.put(url, { shipment_id: shipmentID });
};

export const updateShipment = ({
  shipmentID,
  body,
  version,
}: {
  shipmentID: string;
  body: Partial<ShipmentUpdateBody> | FormData;
  version?: APIVersion;
}) => {
  const api = getAPIFromDomain("logistics", version ?? 1);
  const url = `/shipments/${shipmentID}`;
  return api.put(url, body);
};
